// extracted by mini-css-extract-plugin
export var emailInputContainer = "EmailSignUp-module--emailInputContainer--2pBu5";
export var input = "EmailSignUp-module--input--AD8vp";
export var confirmEmailButton = "EmailSignUp-module--confirmEmailButton--1i-Da";
export var label = "EmailSignUp-module--label--1bkP2";
export var response = "EmailSignUp-module--response--2Itu7";